<template>

  <div class="row g-0">
    <div class="col-12 col-lg-10 m-auto py-3">
      <div class="row g-0 ">
        <div class="col-12 m-0 p-0">
          <img :src="`${publicPath}img/404.svg`" class="img-responsive" style="max-height:300px ">
          <div class="row justify-content-center">
            <div class="col-12 col-xxl-10 p-5">
              <h2 class="mb-4 px-0 px-lg-5">Uuuups!<br><br>{{ $t('page-not-found') }}<br></h2>
              <localized-link to="/" class="footerLink">{{ $t('back-to-home') }}</localized-link>
              <br><br><br>
            </div>
          </div>
        </div>
        <a href="https://storyset.com/web" target="_blank" style="font-size: 9px" class="footerLink">Web illustrations by Storyset</a>
      </div>
    </div>
  </div>


</template>

<script>
  export default {
    name: "PageNotFound",
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    }
  };
</script>

